import dayjs from "dayjs";
import React from "react";
import { useHistory } from "react-router-dom";
import { shortIdGenerator } from "../../../customFunction/IDGenerator";
import { IoAdd } from "react-icons/io5";
import ShowPaginationData from "../../../components/UI/TableView/ShowPaginationData";

function CaffeteriaGuestUserScreen() {
  const history = useHistory();

  const { columns, id, label, url, href } = {
    id: "cafeteria-guest-users",
    label: "cafeteria-guest-users",
    href: "/",
    columns: [
      {
        label: "collectionId",
        value: (a) => a._id,
      },
      { label: "qty", value: (a) => a.collections.length },
      { label: "price", value: (a) => a.collections[0].wallet.money },
      {
        label: "date",
        value: (a) => dayjs(a.collections[0].createdAt).format("YYYY-MM-DD HH:mm"),
      },
    ],
    url: (centerId) => "/cafeteria-guest-users?" + centerId,
  };

  const onClickItem = (data) => {
    // console.log({data})
    history.push(`${window.location.pathname}/${data}`);
  };

  return (
    <div className='flex flex-1 w-full h-full mt-10'>
      <div className='flex flex-1 w-full h-full mt-10'>
        <ShowPaginationData
          onClickItem={(_id) => onClickItem(_id)}
          hrefId={'_id'}
          rightButton={
            <div className='cursor-pointer'>
              <IoAdd
                size={40}
                onClick={() => {
                  let id = shortIdGenerator();
                  history.push(`${window.location.pathname}/${id}?isNew=true`);
                }
                }
              />
            </div>
          }
          columns={columns}
          href={href}
          id={id}
          label={label}
          url={url}
        />
      </div>
    </div>
  );
}

export default CaffeteriaGuestUserScreen;
